import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2.667 14a.667.667 0 0 0 .666.667h9.334a.667.667 0 1 0 0-1.334H3.333a.667.667 0 0 0-.666.667m5.08-12.613a.7.7 0 0 0-.22.14L4.86 4.193a.67.67 0 0 0 .947.947l1.526-1.533v7.726a.667.667 0 1 0 1.334 0V3.607l1.526 1.533a.667.667 0 0 0 1.093-.217.67.67 0 0 0-.146-.73L8.473 1.527a.7.7 0 0 0-.22-.14.67.67 0 0 0-.506 0"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })